export class CheckoutFormValues {
    customer: {};
    cosigner: {};
    vehicle: {};
    lienholder: {};
    creditInsurance: {};
    creditInsuranceForm: {};
    borrowInfoForm: {};
    coverageInfoForm: {};
    financeForm: {};
    customerFormValid: boolean;
    cosignerFormValid: boolean;
    vehicleFormValid: boolean;
    lienholderFormValid: boolean;
    borrowerInfoFormValid: boolean;
    creditInsuranceFormValid: boolean;
    coverageInfoFormFormValid: boolean;
    financeFormValid: boolean;

    constructor() {
        this.customer = {};
        this.cosigner = {};
        this.vehicle = {};
        this.lienholder = {};
        this.creditInsuranceForm = {};
        this.borrowInfoForm = {};
        this.coverageInfoForm = {};
        this.financeForm = {};
        this.customerFormValid = false;
        this.cosignerFormValid = false;
        this.vehicleFormValid = false;
        this.lienholderFormValid = false;
        this.borrowerInfoFormValid = false;
        this.creditInsuranceFormValid = false;
        this.coverageInfoFormFormValid = false;
        this.financeFormValid = false;
    }
}
